<script lang="ts" setup>
import type { ICredit } from '~/components/entity/credit'

const props = defineProps<{
  credit: ICredit
}>()

const registrationTrueKeys = computed(() =>
  Object.entries(props.credit?.registration || {})
    .filter(([_, value]) => value)
    .map(([key]) => key)
)

const purposeTrueKeys = computed(() =>
  Object.entries(props.credit?.purpose || {})
    .filter(([_, value]) => value)
    .map(([key]) => key)
)

const repaymentMethodTrueKeys = computed(() =>
  Object.entries(props.credit?.repayment_method || {})
    .filter(([_, value]) => value)
    .map(([key]) => key)
)
</script>

<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-2">
    <div v-if="credit.rates?.length">
      <div class="SecondaryTextHeadings">
        {{ $t('widget.credit_page.info_items.rate') }}
      </div>
      <div class="font-semibold">
        {{ credit.min_rate }}
      </div>
    </div>

    <div v-if="credit.currencies?.length">
      <div class="SecondaryTextHeadings">{{ $t('common.currency') }}</div>
      <div class="font-semibold">
        <span>{{ credit.currencies.map((i) => i.code).join(', ') }}</span>
      </div>
    </div>

    <div v-if="credit.registration && registrationTrueKeys.length">
      <div class="SecondaryTextHeadings">
        {{ $t('widget.credit_page.info_items.registration') }}
      </div>
      <div class="font-semibold">
        {{
          registrationTrueKeys
            .map((key) => $t(`widget.credit_page.info_items.registration_labels.${key}`))
            .join(', ')
        }}
      </div>
    </div>

    <div v-if="credit.max_period">
      <div class="SecondaryTextHeadings">{{ $t('common.term') }}</div>
      <div class="font-semibold">
        {{ credit.max_period }}
      </div>
    </div>

    <div v-if="credit.purpose && purposeTrueKeys.length">
      <div class="SecondaryTextHeadings">
        {{ $t('common.credit_purpose') }}
      </div>
      <div class="font-semibold">
        {{
          purposeTrueKeys
            .map((key) => $t(`widget.credit_page.info_items.purpose_labels.${key}`))
            .join(', ')
        }}
      </div>
    </div>

    <div v-if="credit.repayment_method && repaymentMethodTrueKeys.length">
      <div class="SecondaryTextHeadings">
        {{ $t('widget.credit_page.info_items.repayment_method') }}
      </div>
      <div class="font-semibold">
        {{
          repaymentMethodTrueKeys
            .map((key) => $t(`widget.credit_page.info_items.repayment_method_labels.${key}`))
            .join(', ')
        }}
      </div>
    </div>
  </div>
</template>
